import { styled, useTheme } from '@mui/material';
import { useLocation, useParams } from 'react-router';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { ROUTES } from '../../constants/routes';
import { useMonthlySingleTimesheet } from '../../queries/hooks/useMonthlySingleTimesheet';
import { getMonthLabel } from '../../utils/formatters';
import { ContentWrapper } from '../layout/styled';
import { DealOwnerSingleTimesheetTable } from './components/SingleTimesheetTable/DealOwnerSingleTimesheetTable';
import { useAtomValue } from 'jotai';
import { isSmallScreenState } from '../../state/UIState';

export function DealOwnerSingleTimesheet() {
  const { id } = useParams();
  const location = useLocation();
  const isSmallScreen = useAtomValue(isSmallScreenState);

  const isAllTimesheets = location.pathname.includes(ROUTES.DEAL_OWNER_ALL_TIMESHEETS);
  const isPendingTimesheets = location.pathname.includes(ROUTES.DEAL_OWNER_PENDING_TIMESHEETS);

  const { colors } = useTheme();
  const { data: singleTimesheet } = useMonthlySingleTimesheet({
    id: Number(id),
  });

  const breadcrumbTitle = singleTimesheet
    ? `${getMonthLabel(singleTimesheet.month)}, ${singleTimesheet.year}`
    : '';

  const breadcrumbConfig = (() => {
    if (isAllTimesheets) {
      return {
        title: 'All Timesheets',
        url: `/${ROUTES.DEAL_OWNER_ALL_TIMESHEETS}`,
      };
    }

    if (isPendingTimesheets) {
      return { title: 'Pending Timesheets', url: `/${ROUTES.DEAL_OWNER_PENDING_TIMESHEETS}` };
    }

    return {
      title: '',
      url: '/',
    };
  })();

  return (
    <>
      <Wrapper>
        <Breadcrumbs
          breadcrumbs={[
            ...(!isAllTimesheets
              ? [
                  {
                    title: 'All Timesheets',
                    color: colors.textAccent.default,
                    url: `/${ROUTES.DEAL_OWNER_ALL_TIMESHEETS}`,
                  },
                ]
              : []),
            {
              title: breadcrumbConfig?.title,
              url: breadcrumbConfig?.url,
              color: colors.textAccent.default,
            },
            { title: breadcrumbTitle || '' },
          ]}
        />
      </Wrapper>
      <ContentWrapper isSmallScreen={isSmallScreen}>
        <DealOwnerSingleTimesheetTable />
      </ContentWrapper>
    </>
  );
}

const Wrapper = styled('div')`
  padding: 28px 36px 0;
`;
